import { FileScanStatus } from '../enums/fileScanStatus.enum';

export class FileMetadataDto {
    public uuid: string;
    public name: string;
    public scanStatus: FileScanStatus;
    public createdBy: string;
    public mimeType: string;
    public extension: string;
    public size: number;

    constructor(
        uuid: string,
        name: string,
        scanStatus: FileScanStatus,
        createdBy: string,
        mimeType: string,
        extension: string,
        size: number,
    ) {
        this.uuid = uuid;
        this.name = name;
        this.scanStatus = scanStatus;
        this.createdBy = createdBy;
        this.mimeType = mimeType;
        this.extension = extension;
        this.size = size;
    }
}
